<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>部分发放使用说明:<br>
					<span>1、单号构成规则:GRBF+202401+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后递交给财务确认=>财务经理审核=>出纳打款。</span><br>
					<span>3、指定月份发放部分工资,不能跨月。与工资单互相锁定。生成时计算当前工资单最大发放金额!</span><br>
					<span>4、查询关键字:单号、申请人。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "userlost",
					"title": "个人违规扣款",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_cw_user_m_lost',
					"upd_action": 'exp15_cw_user_m_lost',
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": 'exp_cw_user_d_lost',
					"d_upd_action": '_cw_user_d_lost',
					"file_action": 'user_apply',
					"p1": 'caiwu',
					"p2": 'apply',
					"p3": '',
					"parm_sel": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						// {
						//   "name": "部门",
						//   "val": "",
						//   "key": "d_name",
						//   "type": "select",
						//   "class": "long1",
						//   "sel_action": "data_dep",
						//   "list": [],
						//   "sel_name": "",
						//   "sel_val": {},
						//   "sel": "5",
						//   "selmore": "1"
						// },
						{
							"name": "还款人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"sel": "2"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "3"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "u2_name",
							"type": "text",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "更新日期",
							"val": "",
							"key": "sys_date",
							"type": "date",
							"class": "long1",
							"sel": "5",
						}
					],
					"parm": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "扣款人",
							"val": "",
							"key": "u_id",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "扣款总金额",
							"val": "",
							"key": "amount_in",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "已经预支",
							"val": "",
							"key": "amount_bef",
							"type": "none",
							"class": "red",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "还款合计",
							"val": "",
							"key": "p_amount",
							"type": "none",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "收款人账号",
							"val": "",
							"key": "rec_card",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "出借人",
							"val": "",
							"key": "out_user",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						}, 
						{
							"name": "业务单号"
						},
						{
							"name": "部门"
						}, 
						{
							"name": "扣款人"
						},
						{
							"name": "扣款合计"
						},

						// {
						// 	"name": "收款人"
						// },
						// {
						// 	"name": "收款人账号"
						// },
						// {
						// 	"name": "出借人"
						// },
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "浏览地址"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "pay_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_kk",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "卡号",
							"val": "",
							"key": "pay_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "是否开票",
							"val": "",
							"key": "is_paper",
							"type": "none",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "公司支付",
							"val": "否",
							"key": "is_pay",
							"type": "none",
							"sel_action": "data_base_ispay",
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [
						{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						// {
						// 	"name": "卡号"
						// },
						{
							"name": "日期"
						},
						// {
						// 	"name": "是否开票"
						// },
						// {
						// 	"name": "公司支付"
						// },
						{
							"name": "备注",
							"class": "long2"
						},

						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});



				// console.log(this.$refs);
				// this.$refs.mybase.load_data();
				// 解决偶尔第一次没有加载完成时再次 调用一下
				// var that = this;
				// this.$nextTick(function() {
				// 	that.$refs.mybase.load_data();
				// });

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>
